module.exports = __webpack_public_path__ + "static/rbox-logo-d6ee76d60ff568029f53cb1c5d8b2ae7.png";